import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { RequestTypes } from '../requestTypes'
import { companyKeys } from '../companyKeys'

export const useMergeCompanies = (
  options?: UseMutationOptions<
    void,
    RequestErrorType,
    RequestTypes['mergeCompanies']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...options,
    ...companyKeys.mergeCompanies,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(companyKeys.getCompanies._def)

      options.onSuccess?.(...args)
    },
  })
}
